import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              {appEntry.title}
            </h2>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-lg lg:max-w-none">
              {appEntry.desc}
            </p>
            <div className="mt-5 flex flex-wrap gap-3 justify-center lg:justify-start">
              {appEntry.features.map((f, i) => (
                <span key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                  <i className="ri-check-line text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
            <div className="mt-6 flex flex-wrap gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-md hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                App Store
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-md hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[400px] lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden bg-background-200" style={{ aspectRatio: '16/9' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%2C%20clean%20dark%20UI%20design%2C%20warm%20accent%20colors%2C%20modern%20mobile%20app%20aesthetic%2C%20soft%20ambient%20lighting%2C%20product%20photography%20style&width=800&height=450&seq=app-showcase&orientation=landscape"
                alt="天美影视APP界面展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}